import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";
import { Template } from "../models/template-upload.model";
import { TemplateUploadService } from "../services/template-upload.service";
import { GetTemplateList } from "./template-upload.action";

/* istanbul ignore file */
export class TemplateUploadStateModel{
  templateList: Template[];
  plantName: string;
  assetType: string;
  plantId:string;
}
  
@State<TemplateUploadStateModel>({
  name: 'template',
  defaults: {
    templateList: [],
    plantName : '',
    assetType : '',
    plantId:''

  }
})
@Injectable()
export class TemplateUploadState {

  constructor(
    private readonly templateUploadService: TemplateUploadService
  ) {}

  @Action(GetTemplateList, {cancelUncompleted: true})
  getTemplateList
  (ctx: StateContext<TemplateUploadStateModel>,
    {plantName , assetType,plantId}: GetTemplateList) {
    const state = ctx.getState();
    return this.templateUploadService.getTemplateList(plantName,assetType,plantId)
    .pipe(
      tap(templateItem => {
        ctx.patchState({ 
          ...state,
          plantName: plantName,
          assetType: assetType,
          plantId:plantId,
          templateList: [...templateItem]
        })
      })
    )
  }
}
